/* ============================================================
   customize.js — wires the design-customize-2026 page.
   Reads ?design=<slug> from the URL, fills the summary panel
   from window.PS_DESIGNS (../products-gallery-2026/designs.js),
   and builds window.CUST26 (with CFG.preset) BEFORE
   custom-form.js runs — script order in the page guarantees it.
   No ?design (or an unknown slug) falls back to a design picker
   plus the generic form, so the page is never a dead end.
   ============================================================ */
(function () {
  'use strict';
  var DATA = window.PS_DESIGNS;
  if (!DATA) return;

  /* On the Shopify port, designs.js ships CDN-absolute img URLs (window.PS_ASSET) —
     no prefix needed there, and the gallery lives at its page handle. */
  var PORTED = /^(\/\/|https?:)/.test(((DATA.designs || [])[0] || {}).image || '');
  var IMG_BASE = PORTED ? '' : '../products-gallery-2026/';
  var GALLERY = PORTED ? '/pages/products-gallery' : '../products-gallery-2026/index.html';
  var SELF = PORTED ? '/pages/design-customize' : 'index.html';

  function $(id) { return document.getElementById(id); }
  function esc(s) {
    return String(s || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  var slug = null;
  try { slug = new URLSearchParams(location.search).get('design'); } catch (e) {}
  var design = null;
  DATA.designs.forEach(function (d) { if (d.slug === slug) design = d; });

  var catByKey = {};
  DATA.categories.forEach(function (c) { catByKey[c.key] = c; });
  function subLabel(d) {
    var label = '';
    catByKey[d.category].subcats.forEach(function (s) { if (s.key === d.subcats[0]) label = s.label; });
    return label;
  }

  /* ---------------- per-category form vocabulary ---------------- */
  var METAL = { key: 'metal', label: 'The metal', single: true, options: ['White gold', 'Yellow gold', 'Rose gold', 'Platinum'] };
  var STONE = { key: 'stone', label: 'The diamonds', single: true, options: ['Natural diamond', 'Lab-grown diamond'] };
  var CATCFG = {
    rings: {
      label: 'ring',
      details: [METAL, STONE, { key: 'size', label: 'Do you know the ring size?', single: true, options: ['I know it', 'I can find out', 'No idea — help me'] }],
      placeholder: 'e.g. Same design, but in rose gold with a slightly thinner band…'
    },
    bracelets: {
      label: 'bracelet',
      details: [METAL, STONE, { key: 'size', label: 'Do you know the wrist size?', single: true, options: ['I know it', 'I can find out'] }],
      placeholder: 'e.g. Same design, but in yellow gold with a safety clasp…'
    },
    earrings: {
      label: 'pair',
      details: [METAL, STONE, { key: 'scale', label: 'How big should they wear?', single: true, options: ['Subtle', 'As shown', 'Bigger'] }],
      placeholder: 'e.g. Same studs, but a touch smaller for everyday wear…'
    },
    pendants: {
      label: 'pendant',
      details: [METAL, STONE, { key: 'chain', label: 'Chain length', single: true, options: ['16 inch', '18 inch', '20 inch'] }],
      placeholder: 'e.g. Same pendant on a longer chain, in white gold…'
    }
  };

  /* ---------------- cross-sell / picker cards ---------------- */
  function card(d, ctxLabel) {
    var li = document.createElement('li');
    li.innerHTML =
      '<a href="' + SELF + (SELF.indexOf('?') > -1 ? '&' : '?') + 'design=' + encodeURIComponent(d.slug) + '">' +
      '<span class="im"><img src="' + esc(IMG_BASE + d.image) + '" alt="' + esc(d.alt) + '" width="' + d.w + '" height="' + d.h + '" loading="lazy"></span>' +
      '<span class="tx"><span class="sc">' + esc(ctxLabel || subLabel(d)) + '</span><span class="nm">' + esc(d.name) + '</span></span>' +
      '</a>';
    return li;
  }

  var moreHost = $('dcz-more');

  if (design) {
    /* ---------------- preset mode ---------------- */
    var cfg = CATCFG[design.category];
    var sub = subLabel(design);
    document.title = design.name + ' — Customize It | PrimeStyle';

    $('dcz-img').src = IMG_BASE + design.image;
    $('dcz-img').alt = design.alt;
    $('dcz-sub').textContent = sub;
    $('dcz-name').textContent = design.name;
    $('dcz-desc').textContent = design.desc ? design.desc + ' Keep it exactly as shown, or change anything about it.' : 'Keep it exactly as shown, or change anything about it — your metal, your stones, your budget.';
    $('dcz-back').href = GALLERY + '#' + design.category + '/' + design.subcats[0];

    window.CUST26 = {
      category: 'design-' + design.slug,
      categoryLabel: cfg.label,
      preset: {
        slug: design.slug,
        name: design.name,
        subcategory: sub,
        image: IMG_BASE + design.image,
        alt: design.alt
      },
      step1: {
        title: 'What would you change about it?',
        help: 'Metal, stones, proportions — or nothing at all. Add photos if another piece has a detail you love. Skipping straight through is fine; the design above already tells us a lot.',
        uploadHint: 'Drop reference photos here',
        textLabel: 'Describe your changes',
        placeholder: cfg.placeholder
      },
      details: cfg.details,
      occasions: ['A proposal', 'A wedding', 'An anniversary', 'A birthday', 'Just because', 'No rush']
    };

    /* cross-sell: same subcategory first, then the rest of the category */
    var pool = [];
    DATA.designs.forEach(function (d) {
      if (d.slug === design.slug) return;
      if (d.subcats.indexOf(design.subcats[0]) > -1) pool.push(d);
    });
    var sameSubCount = pool.length;
    DATA.designs.forEach(function (d) {
      if (d.slug === design.slug || pool.indexOf(d) > -1) return;
      if (d.category === design.category) pool.push(d);
    });
    $('dcz-more-h').textContent = 'More ' + sub.toLowerCase() + ' to start from.';
    pool.slice(0, 4).forEach(function (d, i) {
      /* Same-subcategory cards wear the rail's label so a cross-listed design
         never shows a foreign eyebrow under a "More <subcategory>" heading. */
      moreHost.appendChild(card(d, i < sameSubCount ? sub : null));
    });
  } else {
    /* ---------------- fallback: no (or unknown) design ---------------- */
    document.title = 'Customize a Design — Free 3D Preview | PrimeStyle';
    $('dcz-visual').hidden = true;
    var summary = $('dcz-visual').parentNode;
    if (summary) summary.classList.add('dcz-summary--solo');
    $('dcz-form-h').textContent = 'Tell us what you have in mind.';
    $('dcz-form-lede').textContent = 'Six short moments, most of them optional. A photo or a few words is enough to start.';
    $('dcz-sub').textContent = 'Design gallery';
    $('dcz-name').textContent = 'Start with a design you love.';
    $('dcz-desc').textContent = 'This page works from a chosen design. Pick one from the gallery — or one of the pieces below — and we’ll rework it around you.';
    var cta = $('dcz-cta');
    cta.textContent = 'BROWSE ALL DESIGNS';
    cta.href = GALLERY;
    cta.className = 'ps-btn';

    window.CUST26 = {
      category: 'jewelry',
      categoryLabel: 'piece',
      details: [METAL, STONE],
      occasions: ['A proposal', 'A wedding', 'An anniversary', 'A birthday', 'Just because', 'No rush']
    };

    /* featured picker: the first design of six different subcategories */
    var seen = {};
    var picks = [];
    DATA.designs.forEach(function (d) {
      var k = d.category + '/' + d.subcats[0];
      if (seen[k] || picks.length >= 4) return;
      seen[k] = true;
      picks.push(d);
    });
    $('dcz-more-h').textContent = 'Or start from one of these.';
    picks.forEach(function (d) { moreHost.appendChild(card(d)); });
  }
})();
